import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import { GuardedUserRoute } from './services/authGuard';
import DashboardLayout from './components/layout/DashboardLayout';
import ProjectsLayout from './components/layout/ProjectsLayout';
import ProjectsPage from './pages/ProjectsPage';
import TeamMembersPage from './pages/TeamMembersPage';
import ApplicationSetupPage from './pages/ApplicationSetupPage';
import RiskIdentificationPage from './pages/RiskIdentificationPage';
import MetricsDefinitionPage from './pages/MetricsDefinitionPage';
import TrustIndexSettingPage from './pages/TrustIndexSettingPage';
import UseCaseDatasetGenerationPage from "./pages/UseCaseDatasetGenerationPage";
import TestEvaluationPage from './pages/TestEvaluationPage';
import TestScoreComputationPage from './pages/TestScoreComputationPage';
import EvaluationDashboardPage from './pages/EvaluationDashboardPage';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        {/* Public Route */}
        <Route path="/" element={<Login />} />

        {/* Protected Routes */}
        <Route element={<GuardedUserRoute />}>
          {/* Projects Page - WITHOUT Sidebar */}
          <Route element={<ProjectsLayout />}>
            <Route path="/projects" element={<ProjectsPage />} />
            <Route path="/team-members" element={<TeamMembersPage />} />
          </Route>

          {/* Project-Specific Pages - WITH Sidebar */}
          <Route element={<DashboardLayout />}>
            <Route path="/project/:projectId/application-setup" element={<ApplicationSetupPage />} />
            <Route path="/project/:projectId/trust-index-settings" element={<TrustIndexSettingPage />} />
            <Route path="/project/:projectId/risk-identification" element={<RiskIdentificationPage />} />
            <Route path="/project/:projectId/metrics-definition" element={<MetricsDefinitionPage />} />
            <Route path="/project/:projectId/usecase-dataset-generation" element={<UseCaseDatasetGenerationPage />} />
            <Route path="/project/:projectId/test-evaluation" element={<TestEvaluationPage />} />
            <Route path="/project/:projectId/test-score-computation" element={<TestScoreComputationPage />} />
            <Route path="/project/:projectId/evaluation-dashboard" element={<EvaluationDashboardPage />} />
          </Route>
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;